import type { EnumObject } from "./types";

export function isEnumValue<T extends EnumObject>(
  enumLikeObject: T,
  value: string | number | null | undefined,
): value is (typeof enumLikeObject)[keyof typeof enumLikeObject] {
  return (
    value !== null &&
    value !== undefined &&
    Object.values(enumLikeObject).includes(value)
  );
}
